import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, Spinner } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, CardHeader } from 'reactstrap';
import axios from 'axios';
import config from '../../../../../config';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';


const HourlySalesReportView = () => {

    if (localStorage.getItem("accessReports") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const getYesterdayDate = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    };

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const [startDate, setStartDate] = useState(getYesterdayDate());
    const [endDate, setEndDate] = useState(getYesterdayDate());
    const [properties, setProperties] = useState([]);
    const [categories, setCategories] = useState([]);
    const [group_name, setGroupName] = useState('');
    const [groups, setGroups] = useState([]);
    const [allSubcategories, setAllSubcategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [allFloors, setAllFloors] = useState([]);
    const [floors, setFloors] = useState([]);
    const [property_id, setPropertyId] = useState('');
    const [category_id, setCategoryId] = useState('');
    const [subcategory_id, setSubcategoryId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [selectedFloor, setSelectedFloor] = useState('');
    const [reportData, setReportData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(50);
    const [validationMessage, setValidationMessage] = useState('');
    const [loading, setLoading] = useState(false)
    const today = new Date().toISOString().split('T')[0];
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const [tooltip, setTooltip] = useState('');

    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');

    const [selectedTenants, setSelectedTenants] = useState([]);
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [searchTenant, setSearchTenant] = useState('');

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };


    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    // 🔽 Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
                const propertyNames = response.data.map(property => property.property_name).join(',');
                setPropertyAccesssNames(propertyNames);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getgroupnames`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setGroups(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/category/getcategorybyconcessionaire`, { category_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        axios
            .post(`${config.hostname}/subcategory/getsubcategorybyconcessionaire`, { subcategory_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setAllSubcategories(response.data);
                setSubcategories(response.data); // Initial set to all subcategories
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        let filteredSubcategories = allSubcategories;

        if (category_id !== '') {
            filteredSubcategories = filteredSubcategories.filter(subcategory => subcategory.category_id._id === category_id);
        }

        setSubcategories(filteredSubcategories);
    }, [category_id]);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;

        if (group_name !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_group_name === group_name);
        }

        if (category_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_category_id._id === category_id);
        }

        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        if (subcategory_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_subcategory_id._id === subcategory_id);
        }

        setTenants(filteredTenants);
    }, [group_name, property_id, category_id, subcategory_id, allTenants]);



    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getfloorsbyconcessionaire`, { concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllFloors(response.data);
                setFloors(getUniqueFloors(response.data));
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredFloors = allFloors;

        if (property_id !== '') {
            filteredFloors = filteredFloors.filter(floor => floor.property_id === property_id);
        }

        setFloors(getUniqueFloors(filteredFloors));
    }, [property_id]);

    const getUniqueFloors = (floors) => {
        const floorNames = new Set();
        return floors.filter(floor => {
            if (!floorNames.has(floor.floor_id.floor_name)) {
                floorNames.add(floor.floor_id.floor_name);
                return true;
            }
            return false;
        });
    };


    const filteredTenants = tenants.filter((tenant) => {
        if (!searchTenant.trim()) return true;

        const search = searchTenant.trim().toLowerCase();

        const name = (tenant.tenant_name || "").toLowerCase();
        const code = (tenant.tenant_code || "").toLowerCase(); // or tenant.tenant_code / tenant_code

        return name.includes(search) || code.includes(search);
    });


    const generateReport = async (e) => {
        e.preventDefault();

        if (endDate < startDate) {
            setValidationMessage("End date cannot be less than start date");
            return;
        } else {
            setValidationMessage("");
        }

        const category_name =
            category_id !== ""
                ? categories.find((c) => c._id === category_id)?.category_name
                : "";
        const property_name =
            property_id !== ""
                ? properties.find((p) => p._id === property_id)?.property_name
                : "";
        const subcategory_name =
            subcategory_id !== ""
                ? subcategories.find((s) => s._id === subcategory_id)?.subcategory_name
                : "";
        const tenant_name =
            tenant_id !== "" ? tenants.find((t) => t._id === tenant_id)?.tenant_store_name : "";

        const data = {
            concessionaire_id,
            property_access: propertyAccessNames,
            start_date: startDate,
            end_date: endDate,
            group_name,
            category_name,
            property_name,
            subcategory_name,
            // tenant_name,
            tenant_id: selectedTenants,
            floor: selectedFloor,
        };

        setLoading(true);

        axios
            .post(`${config.hostname}/reports/gethourlysalesreport`, data, configheader)
            .then((response) => {
                const rows = response?.data || [];      // <-- IMPORTANT
                const pivoted = pivotHourly(rows);            // <-- PIVOT HERE
                setReportData(pivoted);
                setLoading(false);
                insertToLog(" generated Hourly sales report");
                console.log("raw:", rows);
                console.log("pivot:", pivoted);
            })
            .catch((error) => {
                toast.error("Error");
                setLoading(false);
                console.log(error);
            });
    };

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Reports",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {
                toast.error('Error')
                console.log(error);

            });
    }


    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const handleGroupChange = (e) => {
        setGroupName(e.target.value);
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
    };

    const handlePropertyChange = (e) => {
        setPropertyId(e.target.value);
        setTenantId('');
        setSelectedFloor('');
        setReportData([]);
        setCurrentPage(0);
    };

    const handleCategoryChange = (e) => {
        setCategoryId(e.target.value);
        setSubcategoryId('')
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
    };

    const handleSubCategoryChange = (e) => {
        setSubcategoryId(e.target.value);
        setTenantId('')
        setReportData([]);
        setCurrentPage(0);
    };


    const handleTenantChange = (e) => {
        const { value, checked } = e.target;

        setSelectedTenants((prev) => {
            if (checked) {
                // Add if not already there
                if (prev.includes(value)) return prev;
                return [...prev, value];
            } else {
                // Remove if unchecked
                return prev.filter((item) => item !== value);
            }
        });

        setReportData([]);
        setCurrentPage(0);
    };


    const handleFloorChange = (e) => {
        setSelectedFloor(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    //const offset = currentPage * itemsPerPage;
    const pageCount = Math.ceil(reportData.length / itemsPerPage);

    const totalTransactionCount = reportData.reduce((sum, item) => sum + item.transaction_count, 0);
    const totalNetSales = reportData.reduce((sum, item) => sum + item.net_sales, 0);


    const sortedReportData = React.useMemo(() => {
        let sortableData = [...reportData];
        if (sortConfig.key !== '') {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [reportData, sortConfig]);

    const currentPageData = sortedReportData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = key => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'asc') {
                return <FontAwesomeIcon icon={faSortUp} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
            if (sortConfig.direction === 'desc') {
                return <FontAwesomeIcon icon={faSortDown} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
        }

    };


    const handleExport = (format) => {
        if (reportData.length > 0) {
            if (format === 'excel') {
                exportToExcel();
                insertToLog(" exported Hourly sales report to excel");
            } else if (format === 'pdf') {
                exportToPDF();
                insertToLog(" exported Hourly sales report to pdf")
            }
        }
    };


    const exportToExcel = () => {
        try {
            const rows =
                currentPageData && currentPageData.length > 0
                    ? currentPageData
                    : reportData || [];

            if (!rows || rows.length === 0) {
                toast?.error?.("No data to export");
                return;
            }

            // ---- headers exactly like your table ----
            const headers = [
                "Tenant Name",
                "Tcode",
                "Property",
                "Category",
                "Subcategory",
                ...HOUR_COLS.map((c) => c.label),
                "Total Net",
            ];

            const colCount = headers.length;
            const padRow = (arr) => {
                const r = Array(colCount).fill("");
                for (let i = 0; i < Math.min(arr.length, colCount); i++) r[i] = arr[i];
                return r;
            };

            // ---- Build selected filter values (only include if selected) ----
            const selectedCategoryName =
                category_id !== ""
                    ? categories.find((c) => c._id === category_id)?.category_name
                    : "";
            const selectedPropertyName =
                property_id !== ""
                    ? properties.find((p) => p._id === property_id)?.property_name
                    : "";
            const selectedSubcategoryName =
                subcategory_id !== ""
                    ? subcategories.find((s) => s._id === subcategory_id)?.subcategory_name
                    : "";

            // Tenants (selectedTenants is array of tenant _id)
            const selectedTenantNames =
                Array.isArray(selectedTenants) && selectedTenants.length > 0
                    ? selectedTenants
                        .map((id) => tenants.find((t) => t._id === id)?.tenant_store_name)
                        .filter(Boolean)
                        .join(", ")
                    : "";

            const selectedFloors =
                Array.isArray(selectedFloor) && selectedFloor.length > 0
                    ? selectedFloor.join(", ")
                    : selectedFloor || "";

            const propertyAccess =
                Array.isArray(propertyAccessNames) && propertyAccessNames.length > 0
                    ? propertyAccessNames.join(", ")
                    : "";

            const filterLines = [];

            // Date is usually always selected in your UI
            if (startDate || endDate) {
                filterLines.push(["Date Range", `${startDate || ""}  to  ${endDate || ""}`]);
            }
            if (selectedPropertyName) filterLines.push(["Property", selectedPropertyName]);
            if (group_name) filterLines.push(["Group", group_name]);
            if (selectedCategoryName) filterLines.push(["Category", selectedCategoryName]);
            if (selectedSubcategoryName) filterLines.push(["Subcategory", selectedSubcategoryName]);
            if (selectedTenantNames) filterLines.push(["Tenant(s)", selectedTenantNames]);
            if (selectedFloors) filterLines.push(["Floor", selectedFloors]);
            if (propertyAccess) filterLines.push(["Property Access", propertyAccess]);

            // ---- Build sheet data (AOA) ----
            const sheetData = [];

            // Heading row (merged across all columns)
            sheetData.push(padRow(["Hourly Sales Report"]));
            sheetData.push(padRow([""])); // blank row

            // Filters
            filterLines.forEach((line) => sheetData.push(padRow(line)));
            if (filterLines.length > 0) sheetData.push(padRow([""])); // blank row after filters

            // Table header
            const headerRowIndex = sheetData.length; // 0-based row index where the table header starts
            sheetData.push(headers);

            // Table rows
            sheetData.push(
                ...rows.map((r) => [
                    r.tenant_name || "",
                    r.tenant_code || "",
                    r.property_name || "",
                    r.category_name || "",
                    r.subcategory_name || "",
                    ...HOUR_COLS.map((c) => Number(r[c.key] || 0)),
                    Number(r.total_net_sales || 0),
                ])
            );

            // Totals row (based on exported rows only)
            const totals = rows.reduce(
                (acc, r) => {
                    for (let h = 0; h < 24; h++) acc[`h${h}`] += Number(r[`h${h}`] || 0);
                    acc.total += Number(r.total_net_sales || 0);
                    return acc;
                },
                {
                    ...Object.fromEntries(Array.from({ length: 24 }, (_, h) => [`h${h}`, 0])),
                    total: 0,
                }
            );

            sheetData.push([
                "Total",
                "",
                "",
                "",
                "",
                ...HOUR_COLS.map((c) => Number(totals[c.key] || 0)),
                Number(totals.total || 0),
            ]);

            // ---- Create worksheet ----
            const ws = XLSX.utils.aoa_to_sheet(sheetData);

            // Merge heading A1 -> last column in row 1
            const lastColLetter = XLSX.utils.encode_col(colCount - 1);
            ws["!merges"] = ws["!merges"] || [];
            ws["!merges"].push({
                s: { r: 0, c: 0 },
                e: { r: 0, c: colCount - 1 },
            });

            // Column widths
            ws["!cols"] = [
                { wch: 28 }, // Tenant Name
                { wch: 12 }, // Tcode
                { wch: 20 }, // Property
                { wch: 18 }, // Category
                { wch: 20 }, // Subcategory
                ...Array.from({ length: 24 }, () => ({ wch: 10 })), // hours
                { wch: 14 }, // Total
            ];

            // Freeze panes: keep top area + first 5 columns while scrolling
            // Freeze rows up to (headerRowIndex + 1) so table header stays visible
            ws["!freeze"] = { xSplit: 5, ySplit: headerRowIndex + 1 };

            // Number format for hour columns + Total Net (from table header row onward)
            const range = XLSX.utils.decode_range(ws["!ref"]);
            const firstDataRow = headerRowIndex + 1; // row after header
            const firstNumberCol = 5; // after 5 descriptor columns
            for (let R = firstDataRow; R <= range.e.r; R++) {
                for (let C = firstNumberCol; C <= range.e.c; C++) {
                    const addr = XLSX.utils.encode_cell({ r: R, c: C });
                    if (ws[addr]) ws[addr].z = "#,##0.00";
                }
            }

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Hourly Sales");

            const fileName = `Hourly_Sales_Report_${startDate || ""}_to_${endDate || ""}.xlsx`;
            XLSX.writeFile(wb, fileName);
        } catch (err) {
            console.error("Export Excel error:", err);
            toast?.error?.("Excel export failed");
        }
    };




    const exportToPDF = () => {
        const doc = new jsPDF('p', 'pt', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Add a heading with a reduced font size
        doc.setFontSize(13); // Reduced font size
        doc.setFont('helvetica', 'bold');
        doc.text('Day wise Report', pageWidth / 2, 20, { align: 'center' });

        // Reset font for metadata with a smaller font size
        doc.setFontSize(7); // Reduced font size by 2
        doc.setFont('helvetica', 'normal');

        // Conditional date display
        const dateDisplay = startDate === endDate
            ? [`Date: ${startDate}`]
            : [`From: ${startDate} To: ${endDate}`];

        // Add additional information at the top of the PDF
        const lineHeight = 8; // Reduced line height
        const startX = 10;
        let startY = 40;

        const metadata = [
            ...dateDisplay.map(item => [item]),
            `Property: ${property_id ? properties.find(p => p._id === property_id)?.property_name : 'All'}`,
            `Category: ${category_id ? categories.find(s => s._id === category_id)?.category_name : 'All'}`,
            `Group: ${group_name ? group_name : 'All'}`,
            `Subcategory: ${subcategory_id ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name : 'All'}`,
            `Tenant: ${tenant_id ? tenants.find(t => t._id === tenant_id)?.tenant_name : 'All'}`,
            `Floor: ${selectedFloor || 'All'}`,
            `Exported By: ${login_name}`,
            `Exported On: ${new Date().toLocaleString()}`,
        ];

        metadata.forEach((text, index) => {
            doc.text(text, startX, startY + (index * lineHeight));
        });

        // Add a space before the table
        startY += metadata.length * lineHeight + 10;

        // Function to split data into chunks
        const chunkArray = (array, chunkSize) => {
            const result = [];
            for (let i = 0; i < array.length; i += chunkSize) {
                result.push(array.slice(i, i + chunkSize));
            }
            return result;
        };

        // Optimize chunk size to fit more rows per page and reduce the number of pages
        const rowsPerPage = Math.floor((pageHeight - startY - 30) / 10);
        const chunkSize = rowsPerPage * 3; // Three tables per page
        const dataChunks = chunkArray(reportData, chunkSize);

        // Footer details
        const totalTransactionCount = reportData.reduce((sum, item) => sum + item.transaction_count, 0);
        const totalNetSales = reportData.reduce((sum, item) => sum + item.net_sales, 0);


        const addFooters = (doc, pageCount) => {
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
                doc.setFontSize(7); // Smaller font size for page number
                doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 20, { align: 'center' });
            }
        };

        const addTotalRow = () => {
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Total', '', '', '', '', '', '', totalTransactionCount, totalNetSales.toLocaleString()]],
                headStyles: { fillColor: [0, 71, 178], textColor: [255, 255, 255], fontSize: 8 },
                bodyStyles: { fillColor: [0, 71, 178], textColor: [255, 255, 255], fontSize: 8 },
                theme: 'grid',
                tableLineWidth: 0.5,
                tableLineColor: [255, 255, 255],
                margin: { top: 10 },
            });
        };

        const processChunk = (chunkIndex) => {
            if (chunkIndex >= dataChunks.length) {
                addTotalRow();
                addFooters(doc, doc.internal.getNumberOfPages());
                doc.save('DaywiseReport.pdf', { compress: true });
                return;
            }

            if (chunkIndex > 0) {
                doc.addPage();
            }

            doc.autoTable({
                startY: chunkIndex === 0 ? startY : 20,
                head: [['Tenant Name', 'Group Name', 'Tenant Code', 'Unit Code', 'Property', 'Subcategory',]],
                body: dataChunks[chunkIndex].map(item => [
                    item.tenant_name,
                    item.tenant_code,
                    item.property_name,
                    item.subcategory_name,
                    item.floor,
                    item.transaction_date,
                    item.transaction_count,
                    // item.net_sales.toFixed(2).toLocaleString()
                    Number(item.net_sales.toFixed(2)).toLocaleString()

                ]),
                headStyles: { fontSize: 7 },
                bodyStyles: { fontSize: 7 },
                margin: { top: 10, bottom: 10, left: 10, right: 10 }, // Reduced margins to minimize blank space
                tableWidth: 'auto', // Adjust the table width to fit the content
                pageBreak: 'auto', // Automatically handle page breaks
            });

            // Process next chunk after a short delay
            setTimeout(() => processChunk(chunkIndex + 1), 0);
        };

        // Start processing chunks
        processChunk(0);
    };

    const reset = () => {
        setStartDate('')
        setEndDate('')
        setPropertyId('');
        setCategoryId('');
        setSubcategoryId('');
        setGroupName('');
        setTenantId('');
        setSelectedFloor('');
        setSelectedTenants([]);
        setSearchTenant('');
        setDropdownOpen(false);
        setReportData([])

    }

    // 24 hour columns
    const HOUR_COLS = Array.from({ length: 24 }, (_, h) => ({
        key: `h${h}`,              // field name in pivot row
        label: `${h}-${h + 1}hr`,  // header text
        hour: h,
    }));

    const fmtMoney = (v) =>
        (v ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    /**
     * rows from API look like:
     * { hour: 0..23, hour_range:"0-1hr", tenant_name, tenant_code, property_name, category_name, subcategory_name,
     *   total_net_sales, total_gross_sales }
     *
     * returns pivoted rows:
     * { tenant_name, tenant_code, property_name, category_name, subcategory_name, h0..h23, total_net_sales }
     */
    function pivotHourly(rows = []) {
        const map = new Map();

        for (const r of rows) {
            const key = [
                r.tenant_code,
                r.property_name,
                r.category_name,
                r.subcategory_name,
                r.tenant_name,
            ].join("||");

            if (!map.has(key)) {
                const base = {
                    tenant_name: r.tenant_name || "",
                    tenant_code: r.tenant_code || "",
                    property_name: r.property_name || "",
                    category_name: r.category_name || "",
                    subcategory_name: r.subcategory_name || "",
                    total_net_sales: 0,
                    total_gross_sales: 0,
                };

                // init 24 buckets
                for (let h = 0; h < 24; h++) base[`h${h}`] = 0;

                map.set(key, base);
            }

            const row = map.get(key);

            const h = Number(r.hour);
            const net = Number(r.total_net_sales || 0);
            const gross = Number(r.total_gross_sales || 0);

            if (!Number.isNaN(h) && h >= 0 && h < 24) {
                row[`h${h}`] += net; // putting NET in hour columns
            }

            row.total_net_sales += net;
            row.total_gross_sales += gross;
        }

        return Array.from(map.values());
    }


    return (
        <Fragment>
            <Form className='theme-form' onSubmit={generateReport}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="startdate">Start Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={startDate}
                                        max={today} onChange={handleStartDateChange} required />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="enddate">End Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={endDate}
                                        max={today} onChange={handleEndDateChange} required />
                                </FormGroup>
                                {validationMessage && (
                                    <span className="text-danger">{validationMessage}</span>
                                )}
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Property</Label>
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">All</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            {/* <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="tenant_id">Floor</Label>
                                    <select name="tenant_id" id="tenant_id" className="form-control"
                                        value={selectedFloor} onChange={handleFloorChange}>
                                        <option value="">All</option>
                                        {floors.map((floor, index) => (
                                            <option key={index} value={floor.floor_id.floor_name}>{floor.floor_id.floor_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col> */}
                        </Row>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="category_id">Category</Label>
                                    <select name="category_id" id="category_id" className="form-control"
                                        value={category_id} onChange={handleCategoryChange}>
                                        <option value="">All</option>
                                        {categories.map(category => (
                                            <option key={category._id} value={category._id}>{category.category_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Sub Category</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={subcategory_id} onChange={handleSubCategoryChange}>
                                        <option value="">All</option>
                                        {subcategories.map(subcategory => (
                                            <option key={subcategory._id} value={subcategory._id}>{subcategory.subcategory_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Group</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={group_name} onChange={handleGroupChange}>
                                        <option value="">All</option>
                                        {groups.map((group, index) => (
                                            <option key={index} value={group}>{group}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            {/* <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="tenant_id">Tenant</Label>
                                    <select name="tenant_id" id="tenant_id" className="form-control"
                                        value={tenant_id} onChange={handleTenantChange}>
                                        <option value="">All</option>
                                        {tenants.map(tenant => (
                                            <option key={tenant._id} value={tenant._id}>{tenant.tenant_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col> */}

                            <Col>
                                <div style={{ position: 'relative', width: '100%' }} ref={dropdownRef}>
                                    <label>Tenants</label>
                                    <div
                                        onClick={toggleDropdown}
                                        style={{
                                            border: '1px solid #ccc',
                                            padding: '8px',
                                            borderRadius: '4px',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <div>Select Tenants</div>
                                        <span style={{ marginLeft: 'auto' }}>&#9662;</span>
                                    </div>
                                    {dropdownOpen && (
                                        <div
                                            style={{
                                                position: 'absolute',
                                                top: '100%',
                                                left: 0,
                                                width: '100%',
                                                backgroundColor: '#fff',
                                                border: '1px solid #ccc',
                                                borderRadius: '4px',
                                                marginTop: '4px',
                                                zIndex: 1,
                                                boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
                                                maxHeight: '250px', // Set the maximum height for the dropdown
                                                overflowY: 'auto' // Scrollable content
                                            }}
                                        >
                                            {/* Search Bar */}
                                            <div style={{ padding: '8px', borderBottom: '1px solid #ccc' }}>
                                                <input
                                                    type="text"
                                                    placeholder="Search tenants..."
                                                    value={searchTenant}
                                                    onChange={(e) => setSearchTenant(e.target.value)}
                                                    style={{
                                                        width: '100%',
                                                        padding: '6px',
                                                        border: '1px solid #ccc',
                                                        borderRadius: '4px'
                                                    }}
                                                />
                                            </div>

                                            {/* Filtered Tenants List */}
                                            {filteredTenants.length > 0 ? (
                                                filteredTenants.map(tenant => (
                                                    <label
                                                        key={tenant._id}
                                                        style={{ display: 'block', padding: '8px', cursor: 'pointer' }}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            value={tenant._id}
                                                            checked={selectedTenants.includes(tenant._id)}
                                                            onChange={handleTenantChange}
                                                            style={{ marginRight: '8px' }}
                                                        />

                                                        {/* 👇 Display code + name */}
                                                        <span style={{ fontWeight: 500 }}>
                                                            {tenant.tenant_store_name}
                                                            {tenant.tenant_code ? ` - ${tenant.tenant_code}` : ""}
                                                        </span>
                                                    </label>
                                                ))
                                            ) : (
                                                <div style={{ padding: '8px', color: 'gray', textAlign: 'center' }}>
                                                    No results found
                                                </div>
                                            )}

                                        </div>
                                    )}
                                </div>
                            </Col>

                        </Row>
                        <Row>
                            <Col >
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }} >Generate Report</Btn>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: reset }} >Reset</Btn>
                            </Col>

                        </Row>


                    </CardBody>
                </Card>
            </Form>
            {loading === true ? (
                <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-3' }} />
                </div>

            ) : (
                <Card>
                    <CardHeader>
                        <Row className="justify-content-end">
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('excel'),
                                        onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                </Btn>
                                {tooltip === 'Export to Excel' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col>
                            {/* <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('pdf'),
                                        onMouseEnter: () => handleMouseEnter('Export to PDF'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFilePdf} size="lg" />
                                </Btn>
                                {tooltip === 'Export to PDF' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col> */}
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Col sm="12" lg="12" xl="12">
                            <div className="table-responsive" style={{ overflowX: "auto" }}>
                                <Table style={{ minWidth: 1800 }}>
                                    <thead>
                                        <tr>
                                            <th onClick={() => requestSort("tenant_name")}>
                                                Tenant Name{getSortIcon("tenant_name")}
                                            </th>
                                            <th onClick={() => requestSort("tenant_code")}>
                                                Tcode{getSortIcon("tenant_code")}
                                            </th>
                                            <th onClick={() => requestSort("property_name")}>
                                                Property{getSortIcon("property_name")}
                                            </th>
                                            <th onClick={() => requestSort("category_name")}>
                                                Category{getSortIcon("category_name")}
                                            </th>
                                            <th onClick={() => requestSort("subcategory_name")}>
                                                Subcategory{getSortIcon("subcategory_name")}
                                            </th>

                                            {HOUR_COLS.map((c) => (
                                                <th key={c.key}>{c.label}</th>
                                            ))}

                                            <th>Total Net</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentPageData.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.tenant_name}</td>
                                                <td>{row.tenant_code}</td>
                                                <td>{row.property_name}</td>
                                                <td>{row.category_name}</td>
                                                <td>{row.subcategory_name}</td>

                                                {HOUR_COLS.map((c) => (
                                                    <td key={c.key}>{fmtMoney(row[c.key])}</td>
                                                ))}

                                                <td>{fmtMoney(row.total_net_sales)}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                    <tfoot>
                                        {(() => {
                                            const totals = reportData.reduce(
                                                (acc, r) => {
                                                    for (let h = 0; h < 24; h++) {
                                                        acc[`h${h}`] += Number(r[`h${h}`] || 0);
                                                    }
                                                    acc.total += Number(r.total_net_sales || 0);
                                                    return acc;
                                                },
                                                {
                                                    ...Object.fromEntries(Array.from({ length: 24 }, (_, h) => [`h${h}`, 0])),
                                                    total: 0,
                                                }
                                            );


                                            // the above line is messy due to inline reduce init; use cleaner version below instead
                                            return null;
                                        })()}

                                        {/* Cleaner totals row */}
                                        <tr>
                                            <td colSpan={5}><b>Total</b></td>

                                            {(() => {
                                                const hourTotals = Array(24).fill(0);
                                                let grandTotal = 0;

                                                for (const r of reportData) {
                                                    for (let h = 0; h < 24; h++) hourTotals[h] += Number(r[`h${h}`] || 0);
                                                    grandTotal += Number(r.total_net_sales || 0);
                                                }

                                                return (
                                                    <>
                                                        {hourTotals.map((v, h) => (
                                                            <td key={h}><b>{fmtMoney(v)}</b></td>
                                                        ))}
                                                        <td><b>{fmtMoney(grandTotal)}</b></td>
                                                    </>
                                                );
                                            })()}
                                        </tr>
                                    </tfoot>
                                </Table>
                            </div>

                            {reportData.length > 50 && (
                                <ReactPaginate
                                    previousLabel={'<<'}
                                    nextLabel={'>>'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                />
                            )}
                        </Col>
                    </CardBody>
                </Card>
            )}
        </Fragment>
    )
}

export default HourlySalesReportView